<!--  -->
<template>
  <div>
    <van-nav-bar
      :title="$t('ShopSet.paySet')"
      left-arrow
      fixed
      z-index="9"
      @click-left="$router.push('/ShopSet/' + sessionStorage.actShopId)"
    >
      <van-icon
        name="./static/img/ok.png"
        slot="right"
        @click="patchPay()"
        style="font-size: 24px;"
      />
    </van-nav-bar>

    <div class="contentWrapper">
      <div class="contentTitle">堂食的支付方式</div>
      <van-checkbox-group v-model="dineResult" direction="horizontal">
        <div v-if="$i18n.locale == 'zh'">
          <template v-for="(item, index) in methodsList">
            <van-checkbox :name="item.id" :key="index">{{
              item.name_cn
            }}</van-checkbox>
          </template>
        </div>
        <div v-if="$i18n.locale == 'hk'">
          <template v-for="(item, index) in methodsList">
            <van-checkbox :name="item.id" :key="index">{{
              item.name_hk
            }}</van-checkbox>
          </template>
        </div>
        <div v-if="$i18n.locale == 'en'">
          <template v-for="(item, index) in methodsList">
            <van-checkbox :name="item.id" :key="index">{{
              item.name_en
            }}</van-checkbox>
          </template>
        </div>
      </van-checkbox-group>
      <div class="contentTitle">外卖的支付方式</div>
      <van-checkbox-group v-model="takeoutResult" direction="horizontal">
        <div v-if="$i18n.locale == 'zh'">
          <template v-for="(item, index) in methodsList">
            <van-checkbox :name="item.id" :key="index">{{
              item.name_cn
            }}</van-checkbox>
          </template>
        </div>
        <div v-if="$i18n.locale == 'hk'">
          <template v-for="(item, index) in methodsList">
            <van-checkbox :name="item.id" :key="index">{{
              item.name_hk
            }}</van-checkbox>
          </template>
        </div>
        <div v-if="$i18n.locale == 'en'">
          <template v-for="(item, index) in methodsList">
            <van-checkbox :name="item.id" :key="index">{{
              item.name_en
            }}</van-checkbox>
          </template>
        </div>
      </van-checkbox-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      methodsList: [],
      dineResult: [],
      takeoutResult: []
    };
  },
  created() {
    this.getShopPay();
    this.getpaymentmethod();
  },
  methods: {
    patchPay() {
      console.log(this.dineResult);
      console.log(this.takeoutResult);
      this.setDine(1);
      this.setDine(2);
      var vm = this;
      setTimeout(function() {
        vm.$router.push("/ShopSet/" + sessionStorage.actShopId);
      }, 2000);
    },
    setDine(category) {
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/store/" + sessionStorage.actShopId + "/method",
        data: {
          category: category, //类型：【1：堂食，2：外带】
          ids:
            category === 1
              ? JSON.stringify(this.dineResult)
              : JSON.stringify(this.takeoutResult)
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
          } else {
            this.$toast({
              type: "fail",
              message: res.data.message
            });
          }
          // this.$toast.clear();
        })
        .catch(err => {
          this.$toast.clear();
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    },
    // 支付类型选择
    getpaymentmethod() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/paymentmethod/outside/index"
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log(res);
            this.methodsList = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("StaffList.message")
          });
        });
    },
    getShopPay() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/store/" + sessionStorage.actShopId + "/show"
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log(res);
            // this.dineResult = res.data.data.insite;
            // this.takeoutResult = res.data.data.outsite;
            if (res.data.data.insite.length > 0) {
              res.data.data.insite.forEach((item, index) => {
                this.dineResult.push(item.id);
              });
            }
            if (res.data.data.outsite.length > 0) {
              res.data.data.outsite.forEach((item, index) => {
                this.takeoutResult.push(item.id);
              });
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("StaffList.message")
          });
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
.contentWrapper {
  padding-top: 0.625rem;
}
.contentWrapper div {
  display: flex;
  flex-wrap: wrap;
}
.contentTitle {
  line-height: 40px;
  font-size: 18px;
  padding: 0 20px;
}
/deep/ .van-checkbox-group {
  padding: 0 20px;
  background-color: #fff;
}
/deep/ .van-checkbox {
  width: 30%;
  height: 2.1875rem;
}
</style>



// WEBPACK FOOTER //
// src/Pay/paySet.vue